/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для страницы торговой марки "Этель"
   */
  app.EtelView = app.View.extend({
    el: '[data-jsview = "etel"]',
    
    events: {
      'click .js-small-image': 'changeBigImage',
      'click .control-play': 'playVideo',
      'click .tm-video-item': 'toggleMainVideo'
    },
    
    run: function () {
      var carouselPadding = 0;
      this.isMobileCarouselConfig = app.isMobile && [1, 1, 1];
      this.newsCarousel = this.addOwlCarousel('.tm-news', this.isMobileCarouselConfig || [1, 3, 4], carouselPadding);
      this.contactsCarousel = this.addOwlCarousel('.tm-contacts', this.isMobileCarouselConfig || [1, 1, 2], carouselPadding);
      this.reviewsCarousel = this.addOwlCarousel('.tm-reviews', this.isMobileCarouselConfig || [1, 2, 3], carouselPadding);
      if (this.$('.tm-video-big').length) {
        var src = this.$('.video-wrapper video').attr('src');
        this.videoView = new app.BaseVideoView({'el': this.$('.video-wrapper'), templateName: '#video-template'});
        this.videoView.render(src);
        this.$('.tm-video-item:first-child').addClass('selected');
        this.videosCarousel = this.addOwlCarousel('.tm-video', this.isMobileCarouselConfig || [1, 3, 4], carouselPadding);
      }
      if (app.isMobile && this.$('.owl-carousel .video-wrapper').length) {
        var that = this;
        carouselPadding = 20;
        this.videosCarousel = this.addOwlCarousel('.tm-video', this.isMobileCarouselConfig || [1, 3, 4], carouselPadding);
        this.initCarouselVideo();
        this.videosCarousel.on('translated.owl.carousel', function () {
          that.$('.video-preview-img').show();
          that.initCarouselVideo();
        });
      }
      this.initEtelImages(carouselPadding);
      if(app.isDesktop){
        this.initCallMeForm();
      }
    },
    
    /**
     * Добавление карусели
     * @param selector класс элемента, к котором находятся дочерние элементы
     * @param itemsCount {Array} Массив чисел с количеством элементов для разных разрешений
     * @param padding {int} паддинг для мобильных каруселей
     */
    addOwlCarousel: function (selector, itemsCount, padding) {
      var $el = this.$el.find(selector);
      var owlConfig = {
        dots: false,
        slideBy: 1,
        responsive: {
          0: {
            items: itemsCount[0],
            nav: true
          },
          420: {
            items: itemsCount[1],
            nav: true
          },
          1280: {
            items: itemsCount[2],
            nav: true
          }
        },
        mouseDrag: false,
        margin: 20
      };
      if (this.$(selector + '-item').length <= 4 && app.isDesktop) {
        owlConfig.nav = false;
      }
      if (padding) {
        owlConfig.stagePadding = padding;
      }
      return $el.owlCarousel(owlConfig);
    },
    
    /**
     * Подготовка большого изображения с каруселью
     */
    initEtelImages: function (carouselPadding) {
      this.photosCarousel = this.addOwlCarousel('.tm-photos', this.isMobileCarouselConfig || [1, 5, 5], carouselPadding);
  
      var bigImage = $('.js-big-image');
      if (bigImage.length){
        this.bigImage = bigImage;
      }
      if (!app.isMobile) {
        this.setAllImagesInactive();
        this.setImageActive($('.js-small-image').first());
      }
    },

    initCarouselVideo: function () {
      var src = this.$('.owl-item.active .video-wrapper video').attr('src');
      this.videoView = new app.BaseVideoView({'el': this.$('.owl-item.active .video-wrapper'), templateName: '#video-template'});
      if (this.videoView.template){
        this.videoView.render(src);
      }
    },
  
    /**
     * Изменить большое изображение
     * @param e
     */
    changeBigImage: function (e) {
      var target = $(e.target).first();
    
      var newImageUrl = target.data('bigImage');
      if (this.bigImage && newImageUrl){
        this.bigImage.attr('src', newImageUrl);
        this.setAllImagesInactive();
        this.setImageActive(target);
      }
    },
  
    /**
     * Сделать все превью изображений неактивными
     */
    setAllImagesInactive: function () {
      $('.js-small-image').addClass('inactive');
      $('.js-small-image').parent().addClass('unfocus');
    },
  
    /**
     * Сделать превью изображения активным
     * @param $el Элемент картинки
     */
    setImageActive: function ($el) {
      $el.removeClass('inactive');
      $el.parent().removeClass('unfocus');
    },

    /**
     * Проигрывание видео
     * @param e
     */
    playVideo: function (e) {
      this.$(e.currentTarget).parent().hide();
      this.videoView.player.play();
    },

    /**
     * Метод для переключения видео.
     * @param e
     */
    toggleMainVideo: function (e) {
      var src = $(e.currentTarget).data('video-src'),
        bigImg = $(e.currentTarget).data('img-src'),
        that = this;
      this.$('.video-preview-img img').attr('src', bigImg);
      this.$('.video-preview-img').show();
      this.$('.tm-video-item').removeClass('selected');
      this.$(e.currentTarget).addClass('selected');
      this.videoView.$el.fadeOut(400, function () {
        that.videoView.render(src);
        that.videoView.$el.fadeIn();
      });
    },

    /**
     * Инициализация форм связи с менеджером
     */
    initCallMeForm: function () {
      $('.contacts-js-popup-opener').each(function () {
        new app.ManagerContactsPopupView({'el': $(this)});
      });
      new app.MessageToManagerFormView();
      new app.MessageToCallMeFormContactGroupView();
    }
  });
})();

}.call(window));